import { FC } from 'react';
import { TooltippedTag } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import RebateTagTooltip from './RebateTagTooltip';

interface RebateTagProps {
    rebateIndex?: number;
    rebateReason?: string | null;
}

const RebateTag: FC<RebateTagProps> = ({ rebateIndex, rebateReason }) => (
    <TooltippedTag
        variant="warning"
        tooltip={rebateReason ? <RebateTagTooltip reason={rebateReason} /> : null}
        data-rebate-tag
    >
        {rebateIndex && rebateIndex > 1 ? `${rebateIndex}X${UnicodeEntity.NoBreakSpace}` : null}
        <LocalizedText textKey={TextKey.Rebate} />
    </TooltippedTag>
);

export default RebateTag;
